export const extractDetails = (objectsList) => {
  const allowedKeys = [
    'payment_type',
    'id_payment',
    'currency',
    'apply_extra_cost',
    'date',
    'amount_to_pay',
    'code',
    'extra_cost',
  ]

  if (
    !objectsList &&
    (!Array.isArray(objectsList) || (Array.isArray(objectsList) && objectsList.length == 0))
  ) {
    return []
  }

  return objectsList.map((obj) => {
    // Crear un nuevo objeto para 'details'
    const details = {}

    // Iterar sobre las claves del objeto
    Object.keys(obj).forEach((key) => {
      if (!allowedKeys.includes(key)) {
        // Si la clave no está en allowedKeys, añadirla a 'details'
        details[key] = obj[key]
      }
    })

    // Añadir 'details' al objeto original
    return { ...obj, details }
  })
}
